export default "__VITE_ASSET__c7899367__"